import React from 'react';
import HeaderContainer, { createPropsFromState } from '@configuratorware/configurator-frontendgui/App/Shared/Containers/Header';
import { connect } from 'react-redux';
import Header from '../../Components/Header';

const mapStateToProps = ({ configurator }) => ({
  ...createPropsFromState(configurator),
});

export default connect(mapStateToProps)((props) => (
  <HeaderContainer
    {...props}
    Component={Header}
  />
));
